/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type AiTutorMessageRole = (typeof AiTutorMessageRole)[keyof typeof AiTutorMessageRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiTutorMessageRole = {
  student: 'student',
  tutor: 'tutor',
  system: 'system',
  evaluator: 'evaluator',
} as const;
